import { render } from "./CustomCommand.vue?vue&type=template&id=c272e26e"
import script from "./CustomCommand.vue?vue&type=script&lang=js"
export * from "./CustomCommand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__